import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import { Box, CircularProgress, Container, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    fontSize: 13,
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

class BolsaTrabajoChoferes extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            errores: null,
            notificaciones: null,
            consultaRealizada: false,

            consulta: {
                ci: '',
            },

            ingresoDatos: {
                pNombre: '',
                sNombre: '',
                pApellido: '',
                sApellido: '',
                ci: '',
                fechNacimiento: '',
                credencialSerie: '',
                credencialNumero: '',
                direccionCalle: '',
                direccionNumero: '',
                direccionLocalidad: '',
                direccionDepartamento: '',
                telefono: '',
                celular: '',
                carneSalud: '',
                sexo: '',
                idPersonas: '',
                archivo: '',
                email: '',
                cicloBasico: '',
                bachillerato: '',
                universidad: '',
                llamado: '',
                tipoInscripcion: '',
                estadoInscripcion: '',
            },

            archivosObligatorios: {
                ciFrente: '',
                ciDorso: '',
                credencialFrente: '',
                credencialDorso: '',
                constanciaDomicilio: '',
                formula69: '',
                escolaridad: '',
                libretaChofer: '',
                historiaLaboral: '',
                cartaCiudadania: '',
                carnePsicofisico: '',
            },

            elimineArchivo: {
                ciFrente: false,
                ciDorso: false,
                credencialFrente: false,
                credencialDorso: false,
                constanciaDomicilio: false,
                formula69: false,
                escolaridad: false,
                libretaChofer: false,
                historiaLaboral: false,
                cartaCiudadania: false,
                carnePsicofisico: false,
            },

            tieneArchivos: false,

            //--------
            departamentos: [],
            estadoEstudios: [],
            auxiliar: [],
            auxiliarNombres: [],
            auxiliarFormacion: [],
            auxiliarNombresFormacion: [],
            //--------
        }
        this.manejarCambiosDatosConsulta = this.manejarCambiosDatosConsulta.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarCambiosDatosDocObligatorios = this.manejarCambiosDatosDocObligatorios.bind(this);
        this.manejarEnvioIngreso = this.manejarEnvioIngreso.bind(this);
        this.deleteArchivo = this.deleteArchivo.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
    }

    async componentDidMount(){
        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentosConcurso.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const estadoEstudio = await fetch(`${Constantes.RUTA_API}/obtener_estadoEstudios.php`);
        const datoEstadoEstudio = await estadoEstudio.json();
        this.setState({
            estadoEstudios: datoEstadoEstudio,
        });
    }

    render(){
        return (
            <>
                <h3>Bolsa Trabajo Choferes</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consultaRealizada
                ?
                    null
                :
                    <Container>
                        <br/>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>Ingrese C.I. (Solo números)</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='ci' value={this.state.consulta.ci} onChange={this.manejarCambiosDatosConsulta}/>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsulta}>Enviar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                }
                {(this.state.estado === 1 || this.state.estado === 2)
                ?
                    <Container>
                        <br/>
                        {/*<fieldset>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Tipo Inscripción</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8", textAlign: 'center'}} id='tipoInscripcion' value={this.state.ingresoDatos.tipoInscripcion} onChange={this.manejarCambiosDatos} >
                                            <option value=''></option>
                                            <option key={1} value={1}>GENERAL</option>
                                            <option key={2} value={2}>PERSONAS TRANS</option>
                                            <option key={3} value={3}>AFRO-DESCENDIENTES</option>
                                            <option key={4} value={4}>PERSONAS VICTIMAS DE DELITOS VIOLENTOS</option>
                                        </select>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </fieldset>*/}
                        <fieldset>
                            <legend>Datos Personales</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Primer Nombre <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input label="sddddd" style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='pNombre' value={this.state.ingresoDatos.pNombre} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Segundo Nombre</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='sNombre' value={this.state.ingresoDatos.sNombre} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Primer Apellido <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='pApellido' value={this.state.ingresoDatos.pApellido} onChange={this.manejarCambiosDatos} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Segundo Apellido</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='sApellido' value={this.state.ingresoDatos.sApellido} onChange={this.manejarCambiosDatos} />
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>C.I. (SIN PUNTOS NI GUIONES) <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='ci' value={this.state.ingresoDatos.ci} onChange={this.manejarCambiosDatos} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Fecha Nacimiento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='fechNacimiento' value={this.state.ingresoDatos.fechNacimiento} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Credencial</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "40%", float: 'left'}} id='credencialSerie' type="text" placeholder='SERIE' value={this.state.ingresoDatos.credencialSerie} onChange={this.manejarCambiosDatos}/><input style={{border: "2px solid #D6EAF8", width: "60%"}} type="number" placeholder='NUMERO' id='credencialNumero' value={this.state.ingresoDatos.credencialNumero} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={6}>
                                        {/*Estolo pongo para un salto de linea */}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Direccion <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='direccionCalle' value={this.state.ingresoDatos.direccionCalle} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Departamento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='direccionDepartamento' value={this.state.ingresoDatos.direccionDepartamento} onChange={this.manejarCambiosDatos} >
                                            <option value=''>DEPARTAMENTO</option>
                                            {this.state.departamentos.map((name) =>
                                                <option
                                                key={name.idDepartamentos}
                                                value={name.idDepartamentos}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Teléfono</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='telefono' value={this.state.ingresoDatos.telefono} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Celular <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='celular' value={this.state.ingresoDatos.celular} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Carné De Salud</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='carneSalud' value={this.state.ingresoDatos.carneSalud} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Sexo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='sexo' value={this.state.ingresoDatos.sexo} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>SEXO</option>
                                            <option value={0}>MASCULINO</option>
                                            <option value={1}>FEMENINO</option>
                                            <option value={2}>OTRO</option>
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Mail <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="email" id='email' value={this.state.ingresoDatos.email} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <fieldset style={{marginTop: '1rem'}}>
                            <legend>Estudios</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Bachillerato <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='bachillerato' value={this.state.ingresoDatos.bachillerato} onChange={this.manejarCambiosDatos} >
                                            <option value=''></option>
                                            {this.state.estadoEstudios.map((name) =>
                                                <option
                                                key={name.idEstadoEstudio}
                                                value={name.idEstadoEstudio}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Universidad <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='universidad' value={this.state.ingresoDatos.universidad} onChange={this.manejarCambiosDatos} >
                                            <option value=''></option>
                                            {this.state.estadoEstudios.map((name) =>
                                                <option
                                                key={name.idEstadoEstudio}
                                                value={name.idEstadoEstudio}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <fieldset>
                            <legend>Documentos</legend>
                            {this.state.estado === 2 ? <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >(Para poder reemplazar los documentos obligatorios vuelva a seleccionar un archivo)</p> : null}
                            <br/>
                            {this.state.estado === 1 ? <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >(Seleccione todos los archivos a enviar)</p> : null}
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Fórmula 69 o su equivalente en UTU <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='formula69' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <br/>
                                        <br/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Libreta De Chofer (CATEGORIA F)<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='libretaChofer' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Carné Psicofísico<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='carnePsicofisico' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    {/*<Grid item xs={12}>
                                        <br/>
                                        <br/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Ticket Pago Certificado Antecedentes Judiciales<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='ticketPagoAntJud' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Ticket Pago ó Certificado Registro Nacional de Violadores y Abusadores Sexuales<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='ticketPagoVioAbu' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>*/}
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <br/>
                                        <br/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>C.I. <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p> (Frente)</Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='ciFrente' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>C.I. <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p> (Dorso)</Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='ciDorso' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <br/>
                                        <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >(Se debe Adjuntar C. CÍVICA ó Carta de Ciudadanía con 3 años de expedida)</p>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>C. CÍVICA <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p> (Frente)</Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='credencialFrente' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>C. CÍVICA <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p> (Dorso)</Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='credencialDorso' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Carta de Ciudadanía con 3 años de expedida<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='cartaCiudadania' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <br/>
                                        <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >(Constancia de domicilio en seccional o factura a su nombre)</p>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>C. DOMICILIO <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='constanciaDomicilio' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <br/>
                                        <br/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Historia Laboral (BPS) <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='historiaLaboral' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Experiencia <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='archivoFormacion' onChange={this.manejarCambiosDatos} multiple accept=".pdf"/>
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <br/>
                    </Container>
                :
                    null
                }
                {this.state.tieneArchivos
                ?
                    <Container>
                        <br/>
                        <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >Documentos Ya Cargados</p>
                        <TableContainer style={{width: '75%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                            <Table sx={{minWidth: 500}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Nombre Documento</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.archivosCargados.map((pdf, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCell>{pdf.name}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf(pdf.name, pdf.data)}>Descargar</button></StyledTableCell>
                                            {pdf.tipo === 0 ? <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.deleteArchivo(pdf)}>Eliminar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                    </Container>
                :
                    null
                }
                {this.state.estado === 1
                ?
                    <Container>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.loading
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        <button style={{marginBottom: '1rem'}} className="btn btn-outline-primary mx-2"  type='button' onClick={this.manejarEnvioIngreso}>Enviar</button>
                        <br/>
                    </Container>
                :
                    this.state.estado === 2
                    ?
                        <Container>
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            {this.state.loading
                            ?
                                <div style={{placeItems: 'center'}}>
                                    <Box sx={{alignItems: 'center'}}>
                                        <CircularProgress/>
                                    </Box>
                                </div>
                            :
                                null
                            }
                            <button style={{marginBottom: '2rem'}} className="btn btn-outline-primary mx-2"  type='button' onClick={this.manejarEnvioModificar}>Modificar</button>
                        </Container>
                    :
                        null
                }
            </>
        )
    }

    manejarCambiosDatosConsulta(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            tieneArchivos: false,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.consulta;
            movimientosActualizado[clave] = valor;
            return{
                consulta: movimientosActualizado,
            };
        })
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        this.setState({
            loading: true,
        });
        const cargaUtil = JSON.stringify([this.state.consulta]);

        const control = await fetch(`${Constantes.RUTA_API}/consultar_ciBolsaChoferes.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();

        this.setState({
            loading: false,
        })

        if(res[2] === 1){
            this.setState({
                estado: 1,
                notificaciones: null,
                consultaRealizada: true,
                datosLlamado: res[6],
                ingresoDatos: {
                    pNombre: '',
                    sNombre: '',
                    pApellido: '',
                    sApellido: '',
                    ci: this.state.consulta.ci,
                    fechNacimiento: '',
                    credencialSerie: '',
                    credencialNumero: '',
                    direccionCalle: '',
                    direccionNumero: '',
                    direccionLocalidad: '',
                    direccionDepartamento: '',
                    telefono: '',
                    celular: '',
                    carneSalud: '',
                    sexo: '',
                    idPersonas: '',
                    archivo: '',
                    email: '',
                    cicloBasico: '',
                    bachillerato: '',
                    universidad: '',
                    llamado: '',
                    tipoInscripcion: '',
                    estadoInscripcion: '',
                },
            })
        }else if (res[2] === 2){
            this.setState({
                estado: 2,
                notificaciones: null,
                consultaRealizada: true,
                errores: null,
                tieneArchivos: res[4],
                archivosCargados: res[3],
                datosLlamado: res[6],
                //archivosObligatorios: res[5],
                
                ingresoDatos: {
                    pNombre: res[1].pNombre,
                    sNombre: res[1].sNombre,
                    pApellido: res[1].pApellido,
                    sApellido: res[1].sApellido,
                    ci: res[1].ci,
                    fechNacimiento: res[1].fNacimiento,
                    credencialSerie: res[1].credencialSerie ? res[1].credencialSerie : '',
                    credencialNumero: res[1].credencialNumero ? res[1].credencialNumero : '',
                    direccionCalle: res[1].direccion,
                    direccionNumero: '',
                    direccionLocalidad: '',
                    direccionDepartamento: res[1].departamento,
                    telefono: res[1].telefono,
                    celular: res[1].celular,
                    carneSalud: res[1].carneSalud ? res[1].carneSalud : '',
                    sexo: res[1].sexo,
                    idPersonas: res[1].idPersonas,
                    archivo: '',
                    email: res[1].email,
                    cicloBasico: res[5].cicloBasico,
                    bachillerato: res[5].bachillerato,
                    universidad: res[5].universidad,
                    llamado: '',
                    tipoInscripcion: '',
                    estadoInscripcion: '',
                },
            })
        }
    }

    async manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor;
        let nombreArchivo = 'Documento';
        if(clave === 'archivo'){
            valor = e.target.files;
            for (let i = 0; i < e.target.files.length; i++) {
                const reader = new FileReader();
                nombreArchivo = e.target.files[i].name;
                this.state.auxiliarNombres[i] = nombreArchivo;
                reader.readAsDataURL(e.target.files[i]);
                reader.onload = (e) => {
                    e.preventDefault();
                    this.setState(state => {
                        //this.state.doc.nombre = nombreArchivo;
                        //this.state.doc.data = e.target.result;
                        //const docu = {nombre: nombreArchivo, data: e.target.result};
                        //this.state.auxiliar[i] = docu;
                        this.state.auxiliar[i] = e.target.result;
                        //this.state.auxiliar[i].nombre = nombreArchivo;
                    });
                };
            }
        }else if(clave === 'archivoFormacion'){
            valor = e.target.files;
            let ingresar = true;
            for (let i = 0; i < e.target.files.length; i++) {
                //----------------
                const archivo = e.target.files[i];
                if (!archivo) return;

                // 🔒 Validar tipo de archivo (solo PDF)
                if (archivo.type !== "application/pdf") {
                    alert("Solo se permiten archivos PDF.");
                    e.target.value = "";
                    ingresar = false;
                    return;
                }

                // 🔒 Validar tamaño máximo (2 MB)
                const maxSize = 2 * 1024 * 1024; // 2 MB en bytes
                if (archivo.size > maxSize) {
                    alert("El archivo no debe superar los 2 MB.");
                    e.target.value = "";
                    ingresar = false;
                    return;
                }
                //----------------
            }
            if(ingresar){
                for(let i = 0; i < e.target.files.length; i++){
                    const reader = new FileReader();
                    nombreArchivo = e.target.files[i].name;
                    this.state.auxiliarNombresFormacion[i] = nombreArchivo;
                    reader.readAsDataURL(e.target.files[i]);
                    reader.onload = (e) => {
                        e.preventDefault();
                        this.setState(state => {
                            this.state.auxiliarFormacion[i] = e.target.result;
                        });
                    };
                }
            }
        }else{
            valor = e.target.value;
        }
        this.setState(state => {
            const movimientosActualizado = state.ingresoDatos;
            if(clave === "pNombre" || clave === "sNombre" || clave === "pApellido" || clave === "sApellido" || clave === 'credencialSerie' || clave === 'direccionCalle'){
                valor = valor.toUpperCase();
            }
            movimientosActualizado[clave] = valor;
            return{
                ingresoDatos: movimientosActualizado,
            };
        })
    }

    /*async manejarCambiosDatosDocObligatorios(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor;
        valor = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e) => {
            e.preventDefault();
            this.setState(state => {
                const movimientosActualizado = state.archivosObligatorios;
                movimientosActualizado[clave] = e.target.result;
                return{
                    archivosObligatorios: movimientosActualizado,
                };
            });
        };
    }*/

    async manejarCambiosDatosDocObligatorios(e) {
        e.preventDefault();
        const clave = e.target.id;
        const archivo = e.target.files[0];

        if (!archivo) return;

        // 🔒 Validar tipo de archivo (solo PDF)
        if (archivo.type !== "application/pdf") {
            alert("Solo se permiten archivos PDF.");
            e.target.value = "";
            return;
        }

        // 🔒 Validar tamaño máximo (2 MB)
        const maxSize = 2 * 1024 * 1024; // 2 MB en bytes
        if (archivo.size > maxSize) {
            alert("El archivo no debe superar los 2 MB.");
            return;
        }

        // ✅ Leer archivo si pasa las validaciones
        const reader = new FileReader();
        reader.readAsDataURL(archivo);

        reader.onload = (loadEvent) => {
            const base64 = loadEvent.target.result;

            this.setState((state) => ({
                archivosObligatorios: {
                    ...state.archivosObligatorios,
                    [clave]: base64,
                },
            }));
        };
    }

    async manejarEnvioIngreso(e){
        e.preventDefault();
        this.setState({
            loading: true,
        });
        const cargaUtil = JSON.stringify([this.state.ingresoDatos, this.state.auxiliar, this.state.auxiliarNombres, this.state.archivosObligatorios, true, this.state.datosLlamado, this.state.auxiliarFormacion, this.state.auxiliarNombresFormacion]);

        const control = await fetch(`${Constantes.RUTA_API}/agregar_personaBolsa.php`,{
            method: 'POST',
            body: cargaUtil,
        })

        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                tieneArchivos: false,
                notificaciones: 'Los datos fueron ingresados correctamente.',
                estado: '',
                consultaRealizada: false,
                consulta: {
                    ci: '',
                },
            })

            const byteCharacters = atob(res[1]); // Decodificar base64
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Crear un Blob y descargar el PDF
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'archivo.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }

    async deleteArchivo(dato) {
    
        //la elimino de base de datos
        this.setState({
            loading: true,
        });
        const cargaUtil = JSON.stringify([dato.idArchivos]);

        const control = await fetch(`${Constantes.RUTA_API}/eliminar_archivoBolsa.php`,{
            method: 'POST',
            body: cargaUtil,
        })

        const res = await control.json();
        this.setState({
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState(prevState => ({
                archivosCargados: prevState.archivosCargados.filter(archivosCargados => archivosCargados.idArchivos !== dato.idArchivos)
            }));
            this.setState(state => {
                const movimientosActualizado = state.elimineArchivo;
                if(dato.tipo === 1){
                    movimientosActualizado['ciFrente'] = true;
                }else if(dato.tipo === 2){
                    movimientosActualizado['ciDorso'] = true;
                }else if(dato.tipo === 3){
                    movimientosActualizado['credencialFrente'] = true;
                }else if(dato.tipo === 4){
                    movimientosActualizado['credencialDorso'] = true;
                }else if(dato.tipo === 5){
                    movimientosActualizado['constanciaDomicilio'] = true;
                }else if(dato.tipo === 6){
                    movimientosActualizado['formula69'] = true;
                }else if(dato.tipo === 7){
                    movimientosActualizado['escolaridad'] = true;
                }else if(dato.tipo === 8){
                    movimientosActualizado['libretaChofer'] = true;
                }else if(dato.tipo === 9){
                    movimientosActualizado['historiaLaboral'] = true;
                }else if(dato.tipo === 10){
                    movimientosActualizado['cartaCiudadania'] = true;
                }else if(dato.tipo === 11){
                    movimientosActualizado['carnePsicofisico'] = true;
                }
                return{
                    elimineArchivo: movimientosActualizado,
                };
            })
        }

    };


    async manejarEnvioModificar(e){
        e.preventDefault();
        this.setState({
            loading: true,
        });
        const cargaUtil = JSON.stringify([this.state.ingresoDatos, this.state.auxiliar, this.state.auxiliarNombres, this.state.archivosObligatorios, false, this.state.datosLlamado, this.state.auxiliarFormacion, this.state.auxiliarNombresFormacion]);

        const control = await fetch(`${Constantes.RUTA_API}/agregar_personaBolsa.php`,{
            method: 'POST',
            body: cargaUtil,
        })

        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                tieneArchivos: false,
                notificaciones: 'Los datos fueron ingresados correctamente.',
                estado: '',
                consultaRealizada: false,
                consulta: {
                    ci: '',
                },
            })

            const byteCharacters = atob(res[1]); // Decodificar base64
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Crear un Blob y descargar el PDF
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'archivo.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }

}

export default BolsaTrabajoChoferes